export default __webpack_public_path__ + "static/media/link-out-icon.46c3028a.svg";